import { render, staticRenderFns } from "./batchAddSource.vue?vue&type=template&id=05196519&scoped=true"
import script from "./batchAddSource.vue?vue&type=script&lang=js"
export * from "./batchAddSource.vue?vue&type=script&lang=js"
import style0 from "./batchAddSource.vue?vue&type=style&index=0&id=05196519&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05196519",
  null
  
)

export default component.exports